import { createSelector } from 'reselect';
import { selectFeatures } from 'core/selectors/app';

// features
export const selectAcquisitionBonusInfoBarEnabled =
  createSelector(selectFeatures, features => features?.hasAcquisitionBonusInfoBarEnabled);
